import { render, staticRenderFns } from "./DocumentListSection.vue?vue&type=template&id=5cea19cf&scoped=true&"
import script from "./DocumentListSection.vue?vue&type=script&lang=js&"
export * from "./DocumentListSection.vue?vue&type=script&lang=js&"
import style0 from "./DocumentListSection.vue?vue&type=style&index=0&id=5cea19cf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cea19cf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDataTable,VIcon,VRow})
